/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_email_tooltip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email is used only for display and Gravatar. BeaconAuth does not verify it and it is not used for login or proving ownership.`)
};

const zh_hans1_settings_email_tooltip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱仅用于显示与获取 Gravatar 头像。BeaconAuth 不验证邮箱，也不会将其用于登录或证明所有权。`)
};

const zh_hant1_settings_email_tooltip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件僅用於顯示與 Gravatar。BeaconAuth 不會驗證它，且不會用於登入或證明所有權。`)
};

const fr_settings_email_tooltip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’e-mail est utilisé uniquement pour l’affichage et Gravatar. BeaconAuth ne le vérifie pas et il n’est pas utilisé pour la connexion ou pour prouver la propriété.`)
};

const de_settings_email_tooltip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die E-Mail wird nur für Anzeige und Gravatar genutzt. BeaconAuth verifiziert sie nicht und sie wird nicht zum Login oder zum Nachweis des Besitzes verwendet.`)
};

const ja_settings_email_tooltip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスは表示と Gravatar のみに使用されます。BeaconAuth は検証せず、ログインや所有権の証明には使用しません。`)
};

const ko_settings_email_tooltip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일은 표시 및 Gravatar에만 사용됩니다. BeaconAuth는 이를 확인하지 않으며, 로그인이나 소유권 증명에 사용되지 않습니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_email_tooltip = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_email_tooltip(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_email_tooltip", locale)
	if (locale === "en") return en_settings_email_tooltip(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_email_tooltip(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_email_tooltip(inputs)
	if (locale === "fr") return fr_settings_email_tooltip(inputs)
	if (locale === "de") return de_settings_email_tooltip(inputs)
	if (locale === "ja") return ja_settings_email_tooltip(inputs)
	return ko_settings_email_tooltip(inputs)
};